import localEnUs from './en-US.json';
import localeSettings from './settings';
import localeLogin from '@/views/login/locale/en-US';

export default {
    ...localeSettings,
    ...localeLogin,
    ...localEnUs,
};
